<template>
  <div>
    <section class="section pt-4 bg-white" id="about">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center mb-5">
              <h5 class="small-title">{{ $t("help.about") }}</h5>
              <h2 v-html="$t('help.about-page.title')"></h2>
            </div>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="text-muted font-size-16">
            <p>
              {{ $t("help.about-page.line-1") }}
            </p>

            <p v-html="$t('help.about-page.line-2')"></p>
            <p v-html="$t('help.about-page.line-3')"></p>
            <p v-html="$t('help.about-page.line-4')"></p>
            <p v-html="$t('help.about-page.line-5')"></p>
            <p v-html="$t('help.about-page.line-6')"></p>
          </div>
        </div>
      </div>
      <!-- end container -->
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
